export const createProps = (properties) => {
  return Object.entries(properties).reduce((acc, [key, value]) => {
    if (value) {
      acc[key] = value;
    }
    return acc;
  }, {});
};
